import {IMapState} from "../store/types";
import {Map} from 'immutable';

type ILayer = Map<string, string>;

export function getInteractiveLayers (mapStyle: IMapState['mapStyle']) {
    try {
        return mapStyle.get('layers')
            .filter((layer: ILayer) => layer &&
                layer.get('interactive') &&
                layer.getIn(['layout', 'visibility']) === 'visible'
            )
            .map((layer: ILayer) => layer.get('id'))
            .toJS();
    } catch (e) {
        console.error(e);
        return [];
    }
}